module.exports = __webpack_public_path__ + "img/normal-visual-small.915464ce.webp";